import { render, staticRenderFns } from "./ProductQuickView.vue?vue&type=template&id=4771d638&"
import script from "./ProductQuickView.vue?vue&type=script&lang=js&"
export * from "./ProductQuickView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports